package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.InvitationDetailUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationDetailUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiInvitationDetailUiFactory {
  @Provides
  @IntoSet
  public fun provideInvitationDetailUiFactoryFactoryMultibinding(invitationDetailUiFactory: InvitationDetailUiFactory): Ui.Factory = invitationDetailUiFactory
}
